export const CYPRESS_DATA = {
  section: 'report-dismissed-section',
  addButton: 'report-dismissed-add',
  importButton: 'report-dismissed-import',
  templateLink: 'report-dismissed-template',
  emptyState: 'report-dismissed-empty-state',
  summary: 'report-dismissed-summary',
  summaryTotal: 'report-dismissed-summary-total',
  summaryErrors: 'report-dismissed-summary-errors',
  summaryWarnings: 'report-dismissed-summary-warnings',
  filters: 'report-dismissed-filters',
  filterAll: 'report-dismissed-filter-all',
  filterErrors: 'report-dismissed-filter-errors',
  filterWarnings: 'report-dismissed-filter-warnings',
  search: 'report-dismissed-search',
  table: 'report-dismissed-table',
  row: 'report-dismissed-row',
  rowStatus: 'report-dismissed-row-status',
  removeRow: 'report-dismissed-remove-row',
  importReplaceDialog: 'report-dismissed-import-replace-dialog',
  importErrors: 'report-dismissed-import-errors',
  importSuccess: 'report-dismissed-import-success',
  allCorrected: 'report-dismissed-all-corrected',
  mobileList: 'report-dismissed-mobile-list',
  mobileCard: 'report-dismissed-mobile-card',
  mobileCardToggle: 'report-dismissed-mobile-card-toggle',
  cell: 'report-dismissed-cell',
  cellInput: 'report-dismissed-cell-input',
};

export const MOBILE_BREAKPOINT_QUERY = '(max-width: 768px)';
